// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';
import { StudentCentreIframes } from 'src/modules/student-centre-iframes/jsx/component.jsx';

// Stateless components

export function StudentCentre(props) {


    function renderPageContent(context) {
        return <StudentCentreIframes />;
    }
    //
    // Render
    //
    return (
        <PortalContext.Consumer>
            {renderPageContent}
        </PortalContext.Consumer>
    );

};
